// extracted by mini-css-extract-plugin
export var container = "_co-0";
export var popoverContent = "_co-1";
export var tosLink = "_co-2";